import React from 'react';
import { ImportOutlined, SettingOutlined } from '@ant-design/icons';

import FinancialPanel from '@totem/components/administration/account/configuration/financialPanel';
import RemoteAccessPanel from '@totem/components/administration/account/configuration/remoteAccessPanel';
import RemoteAccessAuditConfigurationContainer from '@totem/components/services/remoteAccess/auditConfiguration/RemoteAccessAuditConfigurationContainer';
import RemoteAccessAuditConfigurationContent from '@totem/components/services/remoteAccess/auditConfiguration/RemoteAccessAuditConfigurationContent';
import NozomiEventConfigSection from '@totem/components/settings/sections/nozomi/eventConfiguration/nozomiEventConfigSection';
import { IBMenuItem } from '@totem/components/ui_components/menus/types';
import { permissions } from '@totem/components/userContext/security/permissions/permissions';
import { UserProfile } from '@totem/types/user';

export const getMenuAdminAccountConfiguration = (userProfile: UserProfile) => {
  const items: IBMenuItem[] = [
    {
      key: 'financial',
      title: 'Financial',
      label: 'Financial',
      description: 'Financial',
      content: <FinancialPanel />,
      icon: <ImportOutlined />,
      hasPermissions: () => {
        return permissions.systemAdministrator.hasPermissions(userProfile);
      },
    },
    {
      key: 'nozomiEventConfiguration',
      title: 'Nozomi Event Configuration',
      label: 'Nozomi Event Configuration',
      description: 'Nozomi Event Configuration',
      route: '/dashboard/deviceTypes',
      content: <NozomiEventConfigSection />,
      icon: <ImportOutlined />,
      hasPermissions: () => {
        return permissions.systemAdministrator.hasPermissions(userProfile);
      },
    },
    {
      key: 'remoteAccessAccess',
      title: 'Remote Access',
      label: 'Remote Access',
      description: 'Remote Access',
      content: <RemoteAccessPanel />,
      icon: <ImportOutlined />,
      hasPermissions: () => {
        return permissions.systemAdministrator.hasPermissions(userProfile);
      },
    },
    {
      key: 'remoteAccessUserAudit',
      title: 'Remote Access User Audit',
      label: 'Remote Access User Audit',
      description: 'Configuration for Remote Access User Audit',
      route: '/dashboard/remoteAccess/auditconfig',
      content: (
        <RemoteAccessAuditConfigurationContainer>
          <RemoteAccessAuditConfigurationContent />
        </RemoteAccessAuditConfigurationContainer>
      ),
      icon: <SettingOutlined />,
      hasPermissions: () => {
        return permissions.remoteAccessAdmin.hasPermissions(userProfile);
      },
    },
  ];

  return items.filter((chk) => chk.hasPermissions(userProfile));
};
